export var InvoiceStreamQueryKey;
(function (InvoiceStreamQueryKey) {
    InvoiceStreamQueryKey["Names"] = "InvoiceStream/Names";
})(InvoiceStreamQueryKey || (InvoiceStreamQueryKey = {}));
